/**
 * Spacing tokens as MUI multipliers (base unit: 8px).
 *
 * Values are multipliers, not pixels — `spacing.md` (2) resolves to 16px through
 * `theme.spacing()`.
 */

// Base unit for the MUI spacing system.
export const SPACING_BASE_UNIT = 8 // 8px

export const spacing = {
  none: 0, // 0px
  xs: 0.5, // 4px
  sm: 1, // 8px
  input: 1.75, // 14px — input/button default padding
  md: 2, // 16px
  lg: 3, // 24px
  xl: 4, // 32px
  '2xl': 5, // 40px
  '3xl': 6, // 48px
} as const

export type Spacing = keyof typeof spacing
